<template>
	
<core-avatar :type="type" :id="id" :size="size" class="card-head" :data-band="band">

	<slot></slot>

</core-avatar>

</template>

<script>

export default {

	props: ['type', 'id', 'size', 'band']

}

</script>

<style scoped>

.card-head {
	width: 100%;
    background-position: 50% 50%;
    background-size: cover;
    border-radius: 4px 4px 0px 0px;
    height: 200px;
	background-color: #fff;
	border: 1px solid #ddd;
	border-bottom: 0px;
}

.is-mobile .card-head {
	height: 160px;
}

.card-head[data-band="10"] { border-bottom: 3px solid transparent; border-color: #249563; }
.card-head[data-band="9"] { border-bottom: 3px solid transparent; border-color: #249563; }
.card-head[data-band="8"] { border-bottom: 3px solid transparent; border-color: #2FC482; }
.card-head[data-band="7"] { border-bottom: 3px solid transparent; border-color: #1d8acd; }
.card-head[data-band="6"] { border-bottom: 3px solid transparent; border-color: #5369a2; }
.card-head[data-band="5"] { border-bottom: 3px solid transparent; border-color: #5369a2; }
.card-head[data-band="4"] { border-bottom: 3px solid transparent; border-color: #df4751; }
.card-head[data-band="3"] { border-bottom: 3px solid transparent; border-color: #df4751; }
.card-head[data-band="2"] { border-bottom: 3px solid transparent; border-color: #db303b; }
.card-head[data-band="1"] { border-bottom: 3px solid transparent; border-color: #db303b; }
.card-head[data-band="0"] { border-bottom: 3px solid transparent; border-color: #db303b; }

</style>
